<div class="row ss-top-menu">
  <div class="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-5">
    <span class="ss-text-light" style="vertical-align: -webkit-baseline-middle;">Dashboard <i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link addCursor" (click) = "backClicked()" style="vertical-align: -webkit-baseline-middle;">Projects</span>
    <span style="vertical-align: -webkit-baseline-middle;" > <i class="rightArrow fa fa-angle-right"></i>  </span>
    <span class="ss-text-dark capitalize" style="vertical-align: -webkit-baseline-middle;" *ngIf="project_name">{{project_name}}</span>
  </div>
</div>
<div class="rk-ui-notification" *ngIf="successalert">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>


<div id="navcontainer" class="nav-chnage">

  <ul class="nav nav-tabs tabs-chng" id="myTab" role="tablist" >
    <li class="nav-item nav-items">
      <a class="nav-link active addCursor text-center mr-3" (click)="selectSet('initial_design')" [ngClass]="{'active': state == 'initial_design'}">Initial Design</a>
    </li>
    <li class="nav-item nav-items">
      <a class="nav-link  addCursor text-center mr-3" (click)="selectSet('final_design')" [ngClass]="{'active': state == 'final_design'}">Final Design</a>
    </li>
    <li class="nav-item nav-items">
      <a class="nav-link  addCursor text-center mr-3" (click)="selectSet('custom')" [ngClass]="{'active': state == 'custom'}" >CUSTOM ELEMENT</a>
    </li>
    <li class="nav-item nav-items">
      <a class="nav-link  addCursor text-center mr-3" (click)="selectSet('floorplan')" [ngClass]="{'active': state == 'floorplan'}" >FLOORPLAN</a>
    </li>
    <li class="nav-item nav-items">
      <a class="nav-link  addCursor text-center mr-3" (click)="selectSet('cad')" [ngClass]="{'active': state == 'cad'}" >CAD Drawings / Elevations</a>
    </li>
    <li class="nav-item nav-items">
      <a class="nav-link  addCursor text-center mr-3" (click)="selectSet('uploaded-boq')" [ngClass]="{'active': state == 'uploaded-boq'}" >Uploaded BOQs</a>
    </li>
    <li class="nav-item nav-items">
      <a class="nav-link  addCursor text-center mr-3" (click)="selectSet('uploaded-ppt')" [ngClass]="{'active': state == 'uploaded-ppt'}" >Uploaded PPTs</a>
    </li>

  </ul>
</div>

<div class="container-fluid container-set">
  <div class="row" style="padding: 16px" *ngIf="this.state == 'initial_design'">
      <div class="col-md-12" >

        <div class="tableDiv " *ngIf="approve_boq_list && approve_boq_list.length>0">
          <div class="table-responsive">
            <table class="table ">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center">#</th>
                  <th>Reference No.</th>
                  <th>Created Date</th>
                  <th>Last Updated</th>
                  <th>Status</th>
                  <!-- <th>Discounted Amount</th> -->
                  <th>Total Amount</th>
                  <th>Paid Amount</th>
                  <!-- <th>Pending Amount</th> -->
                  <th>Percent Discount</th>
                  <th class="lastTh">Discount Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
              <tr *ngFor="let obj of approve_boq_list; let i = index" [attr.data-index]="i">


                <td class="text-center ">{{i+1}} </td>
                  <td class="capitalize addCursor" style="color: blue;"><a class="addCursor ss-link" href="" [routerLink]="['/projects/'+project_id+'/boq/'+obj.quotation.id]">{{obj.quotation.reference_number}}</a></td>
                  <td class="">{{obj.created_at | date:'dd/MMM/yyy h:mm a'}}</td>
                  <td>{{obj.updated_at | date:'dd/MMM/yyy h:mm a'}}</td>
                  <td class="capitalize">{{obj.quotation.status}}</td>
                  <!-- <td class="capitalize minWidthForTd"><i class="fa fa-inr mr-1"></i>{{obj.final_amount }}</td> -->
                  <td class="minWidthForTd">
                    <i class="fa fa-inr mr-1"></i>
                    <span *ngIf="obj.quotation.total_amount" >{{obj.quotation.total_amount}}</span>
                    <span *ngIf="!obj.quotation.total_amount">0</span>
                  </td>
                  <td class="minWidthForTd">
                    <i class="fa fa-inr mr-1"></i>
                    <span *ngIf="obj.quotation.paid_amount">{{obj.quotation.paid_amount}}</span>
                    <span *ngIf="!obj.quotation.paid_amount">0</span>
                  </td>
                  <!-- <td class="minWidthForTd"><i class="fa fa-inr mr-1"></i> {{obj.quotation.balance}}</td> -->
                  <td>
                    <span *ngIf="obj.discount_value">{{obj.discount_value}}</span>
                    <span *ngIf="!obj.discount_value">0</span>
                  </td>
                  <td>{{obj.discount_status | replaceChar}}</td>

                  <td>
                    <div class="row">
                      <!-- <div class="col-md-6" *ngIf="obj.proposal_type == 'final_design' && ['true','false'].includes(obj.quotation.category_approval) == true">
                        <button type="button" class="btn btn-primary btn-sm btn-success" (click)="confirmAndApproveQuote(obj.quotation.id,'true')">Approve Quote</button>

                      </div>
                      <div class="col-md-6" *ngIf="obj.proposal_type == 'final_design' && ['true','false'].includes(obj.quotation.category_approval) == true">

                        <button type="button" class="btn btn-primary btn-sm btn-danger" (click)="confirmAndApproveQuote(obj.quotation.id,'false')" *ngIf="obj.quotation.cm_approval == true">Reject Quote</button>
                      </div> -->
                    </div>

                  </td>



              </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 not-found " *ngIf="approve_boq_list && approve_boq_list.length== 0">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
          </div>
      </div>

  </div>
  <div class="row" style="padding: 16px" *ngIf="this.state == 'final_design'">
      <div class="col-md-12" >

        <div class="tableDiv " *ngIf="approve_boq_list && approve_boq_list.length>0">
          <div class="table-responsive">
            <table class="table ">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center">#</th>
                  <th>Reference No.</th>
                  <th>Created Date</th>
                  <th>Last Updated</th>
                  <th>Status</th>
                  <!-- <th>Discounted Amount</th> -->
                  <th>Total Amount</th>
                  <th>Paid Amount</th>
                  <!-- <th>Pending Amount</th> -->
                  <th>Percent Discount</th>
                  <th class="lastTh">Discount Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
              <tr *ngFor="let obj of approve_boq_list; let i = index" [attr.data-index]="i">


                <td class="text-center ">{{i+1}} </td>
                  <td class="capitalize addCursor" style="color: blue;"><a class="addCursor ss-link" href="" [routerLink]="['/projects/'+project_id+'/boq/'+obj.quotation.id]">{{obj.quotation.reference_number}}</a></td>
                  <td class="">{{obj.created_at | date:'dd/MMM/yyy h:mm a'}}</td>
                  <td>{{obj.updated_at | date:'dd/MMM/yyy h:mm a'}}</td>
                  <td class="capitalize">{{obj.quotation.status}}</td>
                  <!-- <td class="capitalize minWidthForTd"><i class="fa fa-inr mr-1"></i>{{obj.final_amount }}</td> -->
                  <td class="minWidthForTd">
                    <i class="fa fa-inr mr-1"></i>
                    <span *ngIf="obj.quotation.total_amount" >{{obj.quotation.total_amount}}</span>
                    <span *ngIf="!obj.quotation.total_amount">0</span>
                  </td>
                  <td class="minWidthForTd">
                    <i class="fa fa-inr mr-1"></i>
                    <span *ngIf="obj.quotation.paid_amount">{{obj.quotation.paid_amount}}</span>
                    <span *ngIf="!obj.quotation.paid_amount">0</span>
                  </td>
                  <!-- <td class="minWidthForTd"><i class="fa fa-inr mr-1"></i> {{obj.quotation.balance}}</td> -->
                  <td>
                    <span *ngIf="obj.discount_value">{{obj.discount_value}}</span>
                    <span *ngIf="!obj.discount_value">0</span>
                  </td>
                  <td>{{obj.discount_status | replaceChar}}</td>

                  <td>
                    <div class="row">

                      <div class="col-md-6" *ngIf="obj.proposal_type == 'final_design' && [true,false].includes(obj.quotation.category_approval) == false">
                        <button type="button" class="btn btn-primary btn-sm btn-success" (click)="confirmAndApproveQuote(obj.quotation.id,true)" *ngIf="obj.have_approved_cad_files == true">Approve </button>

                      </div>
                      <div class="col-md-6" *ngIf="obj.proposal_type == 'final_design' && [true,false].includes(obj.quotation.category_approval) == false">

                        <button type="button" class="btn btn-primary btn-sm btn-danger" (click)="confirmAndApproveQuote(obj.quotation.id,false)" *ngIf="obj.quotation.cm_approval != false && obj.have_approved_cad_files == true">Reject </button>
                      </div>
                    </div>

                  </td>



              </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 not-found " *ngIf="approve_boq_list && approve_boq_list.length== 0">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
          </div>
      </div>

  </div>


  <!-- List For Custom Element -->
  <div class="row" style="padding: 16px" *ngIf="this.state == 'custom' ">
    <div class="col-md-4" *ngFor="let obj of customList;let i = index" [attr.data-index]="i">
          <div class="card myCard mb-4">

            <div class="ribbon ribbon-top-right">

            <span class="pull-right" *ngIf="obj.photo != '/images/original/missing.png'"><a  href="{{obj.photo}}" download><i class="fa fa-download dwnld" aria-hidden="true"></i></a></span>
            <img  *ngIf="obj.image_available == true" class="card-img-top px-2 pt-2" src="{{ obj.photo }}" alt="Card image cap">
            <img  *ngIf="obj.photo == '/images/original/missing.png'" class="card-img-top px-2 pt-2" src="../../../../../assets/img/no_image.svg" alt="Card image cap">
            <img  *ngIf="obj.image_available == false" class="card-img-top px-2 pt-2" src="../../../../../assets/img/no_image.svg" alt="Card image cap">
            <div class="card-body py-2">
              <h6 class="capitalize hdng-chng">{{ obj.name }}
              </h6>
              <p>Shutter Finish:<span class="ml-2">{{ obj.shutter_finish }}</span></p>
              <p>Core Material:<span class="ml-2">{{ obj.core_material }}</span></p>
              <p>Dimension:<span class="ml-2">{{ obj.dimension }}</span></p>
              <p>Remark:<span class="ml-2">{{ obj.designer_remark }}</span></p>
              <p>Price:<span class="ml-2">{{ obj.ask_price }}</span></p>
              <p *ngIf="obj.price">My Price:<span class="ml-2">{{ obj.price }}</span></p>
              <p *ngIf="obj.category_remark">My Remark:<span class="ml-2">{{ obj.category_remark }}</span></p>

              <div class="row">
                <div class="col-12" *ngIf="!obj.price">
                  <form [formGroup]="priceForm"  >
                    <p>My Price:<span> <input type="number" class="mb-2" placeholder="Price" formControlName = "price" name="price"></span></p>
                    <p>My Reamrk:<span> <textarea type="text" class="" placeholder="Remarks..." formControlName = "category_remark" rows="4"></textarea></span></p>
                    <p class="pull-left mt-3"><a class="btn btn-pink btn-chng pull-right" href="{{obj.photo}}" download>
                  Download
                    </a></p>
                    <div class="border-change">
                      <button class="btn btn-pink pull-right mt-3" type="submit" (click)="onSubmit(obj.id)">submit</button>
                    </div>

                  </form>
                </div>

              </div>

            </div>
          </div>
        </div>
    </div>
    <div class="col-md-12 not-found " *ngIf="customList && customList.length==0 ">
        <div class="boq-img">
          <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
        </div>
        <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
    </div>

  </div>
  <app-category-floorplan [floorplan_list] = 'floorplan_list' *ngIf="this.state == 'floorplan'"></app-category-floorplan>
  <app-category-cad-elevation [cad_list] = 'cad_list' *ngIf="this.state == 'cad'"></app-category-cad-elevation>
  <app-category-boq [boq_list] = 'boq_list' *ngIf="this.state == 'uploaded-boq'"></app-category-boq>
  <app-category-ppt [ppt_list] = 'boq_list' *ngIf="this.state == 'uploaded-ppt'"></app-category-ppt>
</div>



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/category/category/view-category/view-category.component.html